import { render, staticRenderFns } from "./user-dialog.vue?vue&type=template&id=64131082&"
import script from "./user-dialog.vue?vue&type=script&lang=js&"
export * from "./user-dialog.vue?vue&type=script&lang=js&"
import style0 from "./user-dialog.vue?vue&type=style&index=0&id=64131082&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports